export const getAdPreviewContainerBaseStyles = (components, { palette = {} } = {}) => ({
  adPreviewContainer: {
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)',
    borderRadius: 6,
  },
  adPreviewContainerError: {
    border: `1px solid ${palette.orange}`,
  },
  adPreviewContainerHeader: {
    display: 'flex',
    padding: [12, 12, 0, 16],
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  adPreviewContainerTitle: {
  },
  adPreviewPlacementContainer: {
    margin: 'auto',
  },
  adPreviewContainerFooter: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});
